module.exports = __webpack_public_path__ + "img/sp-icon-input-minus.f119bcc8.svg";